import { Devices } from '../service/Devices';

/**
 *
 * @param classes -
 * @returns A string of CSS classes
 */
export const makeClass: (
  classes: Array<string | boolean | undefined>
) => string = (classes: Array<string | boolean | undefined>) =>
  classes
    .filter((e) => e)
    .join(' ')
    .trim();

/**
 * Returns the browser window if available.
 */
export const WINDOW: Window | undefined =
  (typeof window === 'object' && window) || undefined;

export type CSSVarType = {
  [key: string]: string | number | undefined;
};
export type CSSVarTypeReturn = {
  [key: string]: string | number;
};

/**
 * Returns valid CSS styles for inline use with `style` React prop.
 * @param obj - Inline CSS styles.
 * @returns Object with valid CSS style values.
 */
export const setCSSVar = (obj: CSSVarType): CSSVarTypeReturn => {
  Object.keys(obj).forEach((key) => obj[key] === undefined && delete obj[key]);

  return obj as CSSVarTypeReturn;
};

export const getPlatform = () => {
  if (Devices.isMobile()) {
    return 'mobile';
  }
  if (Devices.isTablet()) return 'tablet';
  return 'desktop';
};
